import { FinancialAccount } from '@/modules/financialaccount/models/FinancialAccount';
import { FinancialAccountMetaType } from '@/modules/financialaccount/constants/FinancialAccountMetaType';
import { FinancialAccountTfsaMeta } from '@/modules/financialaccount/models/meta/FinancialAccountTfsaMeta';
import { FinancialAccountRrifMeta } from '@/modules/financialaccount/models/meta/FinancialAccountRrifMeta';
import { FinancialAccountMeta } from '@/modules/financialaccount/models/meta/FinancialAccountMeta';

export class FinancialAccountMetaFactory {
  static factory(model: Partial<FinancialAccount>): FinancialAccountMeta | null {
    switch (model.metaType) {
      case FinancialAccountMetaType.FINANCIAL_ACCOUNT_RRIF_META:
        return FinancialAccountRrifMeta.mapModel(model.meta);
      case FinancialAccountMetaType.FINANCIAL_ACCOUNT_TFSA_META:
        return FinancialAccountTfsaMeta.mapModel(model.meta);
      default:
        return null;
    }
  }
}
